<template>
    <div id="app">
      <fix-nav-bar ></fix-nav-bar>
      <topbox > </topbox>
      <nav-bar ></nav-bar>
      <mal-swiper ></mal-swiper>
      <mal-body ></mal-body>
    </div>
</template>

<script>
    import topbox from './views/mainpage/Topbox'
    import NavBar from './views/mainpage/NavBar.vue'
    import MalSwiper from './views/mainpage/MalSwiper.vue'
    import MalBody from './views/mainpage/MalBody.vue'
    import FixNavBar from './views/mainpage/FixNavBar.vue'
    import api from './api' // 导入api接口
    export default {
        components: {
            'topbox': topbox,
            'nav-bar': NavBar,
            'mal-swiper':MalSwiper,
            'mal-body':MalBody,
            'fix-nav-bar':FixNavBar
        },
        data(){
            return {
              source :this.$store.state.source
            }
        },
        beforeCreate () {
          document.title = this.$store.state.malMainPageConfig.constant.title
        }
        
    }
</script>

<style lang="scss">
  body{
    margin: 0px;
    background: #f5f5f5;
  }
</style>
